import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationConfiguartionService {

  constructor(private backendService: BackendService) { }

  private path = '/application-configuration';


  saveApplicationConfiguration(criteria) {
    return this.backendService.post(this.path, { data: criteria, });
  }

  getApplicationConfiguration() {

    return this.backendService.get(this.path);
  }


}